import { useMutation } from "@apollo/client"
import { CREATE_GEOFENCE_EVENT } from "../entities/tracking/graphql/mutation"
import { EGeofenceEventType, IGeoJsonPoint } from "src/entities/tracking/geofences/interface"

export const useGeofenceEvent = () => {
    const [createGeofenceEvent] = useMutation(CREATE_GEOFENCE_EVENT)

    const trackGeofenceStatus = async (
        geofenceId: string,
        eventType: EGeofenceEventType,
        vehicleId: string | null,
        latitude: number,
        longitude: number
    ) => {
        if (!geofenceId) return

        const gps: IGeoJsonPoint = {
            type: "Point",
            coordinates: [longitude, latitude],
        }

        try {
            await createGeofenceEvent({
                variables: {
                    record: {
                        geofenceId,
                        eventType,
                        vehicleId,
                        gps,
                    },
                },
            })
        } catch (error) {
            console.error("❌ Geofence event mutation failed", error)
        }
    }

    return { trackGeofenceStatus }
}
